import { render, staticRenderFns } from "./DialogPoliticaPrivacidade.vue?vue&type=template&id=68020c79&"
import script from "./DialogPoliticaPrivacidade.vue?vue&type=script&lang=js&"
export * from "./DialogPoliticaPrivacidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports